export var ScheduleType;
(function (ScheduleType) {
    ScheduleType["GROUP"] = "GROUP";
    ScheduleType["INDIVIDUAL"] = "INDIVIDUAL";
})(ScheduleType || (ScheduleType = {}));
export var RecurrencyType;
(function (RecurrencyType) {
    RecurrencyType["SINGLE"] = "SINGLE";
    RecurrencyType["WEEKLY"] = "WEEKLY";
})(RecurrencyType || (RecurrencyType = {}));
export var DayOfWeek;
(function (DayOfWeek) {
    DayOfWeek["MONDAY"] = "MONDAY";
    DayOfWeek["TUESDAY"] = "TUESDAY";
    DayOfWeek["WEDNESDAY"] = "WEDNESDAY";
    DayOfWeek["THURSDAY"] = "THURSDAY";
    DayOfWeek["FRIDAY"] = "FRIDAY";
    DayOfWeek["SATURDAY"] = "SATURDAY";
    DayOfWeek["SUNDAY"] = "SUNDAY";
})(DayOfWeek || (DayOfWeek = {}));
export var ScheduleSessionAttendanceStatus;
(function (ScheduleSessionAttendanceStatus) {
    ScheduleSessionAttendanceStatus["CONFIRMED"] = "CONFIRMED";
    ScheduleSessionAttendanceStatus["CANCELED"] = "CANCELED";
    ScheduleSessionAttendanceStatus["TRIAL"] = "TRIAL";
    ScheduleSessionAttendanceStatus["REPOSITION"] = "REPOSITION";
    ScheduleSessionAttendanceStatus["PAUSED"] = "PAUSED";
})(ScheduleSessionAttendanceStatus || (ScheduleSessionAttendanceStatus = {}));
// Session type for single session scheduling (Trial, Reposition, One Time Session)
export var SingleSessionType;
(function (SingleSessionType) {
    SingleSessionType["TRIAL"] = "TRIAL";
    SingleSessionType["REPOSITION"] = "REPOSITION";
    SingleSessionType["ONE_TIME_SESSION"] = "ONE_TIME_SESSION";
})(SingleSessionType || (SingleSessionType = {}));
// Helper types for display labels
export const SCHEDULE_TYPE_LABELS = {
    [ScheduleType.GROUP]: "Group",
    [ScheduleType.INDIVIDUAL]: "Individual",
};
export const RECURRENCY_TYPE_LABELS = {
    [RecurrencyType.SINGLE]: "Single Session",
    [RecurrencyType.WEEKLY]: "Weekly",
};
export const DAY_OF_WEEK_LABELS = {
    [DayOfWeek.MONDAY]: "Monday",
    [DayOfWeek.TUESDAY]: "Tuesday",
    [DayOfWeek.WEDNESDAY]: "Wednesday",
    [DayOfWeek.THURSDAY]: "Thursday",
    [DayOfWeek.FRIDAY]: "Friday",
    [DayOfWeek.SATURDAY]: "Saturday",
    [DayOfWeek.SUNDAY]: "Sunday",
};
// Helper function to get schedule display name
export const getScheduleDisplayName = (schedule) => {
    return schedule.name;
};
// Helper function to format schedule time
export const formatScheduleTime = (startTime, endTime) => {
    // Handle both string (HH:MM) and Date formats for backward compatibility
    let start;
    let end;
    if (typeof startTime === "string") {
        // Already in HH:MM format
        start = startTime;
    }
    else {
        // Convert Date to HH:MM format
        start = startTime.toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
        });
    }
    if (typeof endTime === "string") {
        // Already in HH:MM format
        end = endTime;
    }
    else {
        // Convert Date to HH:MM format
        end = endTime.toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
        });
    }
    return `${start} - ${end}`;
};
// Helper function to format days of week
export const formatDaysOfWeek = (daysOfWeek) => {
    if (daysOfWeek.length === 0)
        return "No days selected";
    if (daysOfWeek.length === 7)
        return "Every day";
    const sortedDays = daysOfWeek.sort((a, b) => {
        const order = [
            DayOfWeek.MONDAY,
            DayOfWeek.TUESDAY,
            DayOfWeek.WEDNESDAY,
            DayOfWeek.THURSDAY,
            DayOfWeek.FRIDAY,
            DayOfWeek.SATURDAY,
            DayOfWeek.SUNDAY,
        ];
        return order.indexOf(a) - order.indexOf(b);
    });
    return sortedDays.map((day) => DAY_OF_WEEK_LABELS[day]).join(", ");
};
export const getStaffMemberDisplayName = (staffMember) => {
    if (!staffMember)
        return "Unknown";
    return `${staffMember.firstName} ${staffMember.lastName}`.trim();
};
//# sourceMappingURL=Schedule.js.map